import { clsx } from "@trydig/ui";
import type React from "react";
import type { BlokIntro } from "@/storyblok";
import { Skeleton } from "../Skeleton";
import styles from "./Intro.module.css";
import { IntroHeight } from "./IntroHeight";

export interface IntroProps
	extends Pick<BlokIntro, "title" | "preamble" | "layout"> {
	large?: boolean;
	breadcrumbs?: React.ReactNode;
	lightMode?: boolean;
}

export const Intro = ({
	title,
	preamble,
	layout = "default",
	breadcrumbs,
	large,
	lightMode,
	...rest
}: IntroProps) => {
	return (
		<header {...rest} className={styles.root} id="page-intro">
			<IntroHeight />
			{breadcrumbs && <div className={styles.breadcrumbs}>{breadcrumbs}</div>}

			<div
				className={clsx(
					styles.content,
					layout === "sideBySide" && styles.sideBySide,
					large && styles.large,
				)}
				data-light={lightMode}
			>
				<h1 className={styles.title}>{title}</h1>
				<p className={styles.preamble}>{preamble}</p>
			</div>
		</header>
	);
};

export const IntroSkeleton = ({
	layout = "default",
	isPlp,
	...rest
}: Pick<BlokIntro, "layout"> & {
	isPlp?: boolean;
}) => {
	return (
		<header {...rest} className={styles.root}>
			<div
				data-is-plp-intro={isPlp}
				className={clsx(
					styles.content,
					layout === "sideBySide" && styles.sideBySide,
				)}
			>
				<Skeleton className={styles.title}>
					Lorem ipsum dolor sit amet.
				</Skeleton>
				<Skeleton className={styles.preamble}>
					Lorem ipsum dolor, sit amet consectetur adipisicing elit. Obcaecati,
					sequi maiores ipsa fugit tenetur, accusantium ab culpa quas architecto
					sunt qui necessitatibus deleniti quidem doloremque repudiandae numquam
					voluptate ullam commodi. Aperiam a, alias velit sequi eius mollitia
					praesentium nesciunt quis?
				</Skeleton>
			</div>
		</header>
	);
};
